<template>
	<div v-if="context.lebenslagen.length" role="region" aria-label="Lebenslagen">
		<nk-wrapper
			v-for="(lebenslagen, lebenslagenIndex) in sortedLebenslagen"
			:key="lebenslagenIndex"
			spacing="md"
		>
			<section>
				<nk-title
					:id="`title-${titleId}`"
					:aria-label="`Alle Lebenslagen mit dem Buchstabe ${lebenslagen.letter}`"
					size="lg"
					tag="h1"
					no-margin
				>
					{{ lebenslagen.letter }}
				</nk-title>
				<nk-nav :aria-labelledby="`title-${titleId}`">
					<nk-nav-item
						v-for="(lebenslage, lebenslageIndex) in lebenslagen.children"
						:key="lebenslageIndex"
						:link="`${
							context.taggingpfad.slice(-1) !== '/'
								? context.taggingpfad + '/'
								: context.taggingpfad
						}${lebenslage.id}`"
					>
						{{ lebenslage.name }}
					</nk-nav-item>
				</nk-nav>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';
import {useId} from '#imports';

/**
 * @prop {array} context.lebenslagen
 * @prop {string} context.taggingpfad
 */
export default {
	name: 'NkTemplateServiceBwLebenslagen',

	mixins: [TemplatesDefault],

	setup() {
		const titleId = useId();
		return {titleId};
	},

	computed: {
		sortedLebenslagen() {
			const group = groupBy(this.context.lebenslagen, o =>
				o.name[0].toUpperCase(),
			);

			return map(group, (value, key) => ({letter: key, children: value}));
		},
	},
};
</script>
